"use client";

import ClientWrapper from "./client.wrapper";

export default function ClientProvider({ children }: any) {
  return <ClientWrapper>{children}</ClientWrapper>;
}
